import React, { useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { nextEvent } from '../../../../../../redux/authentication/actionCreator';
import "./KYCCompleted.scss"


function EKYCCheck() {

  const homePage = () => {
    window.location.replace('/');
  };

  return (
    <Dialog
      open={true}
      className="error-dialog"

      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <div className="dialog-content">
        <h2 style={{ textAlign: 'center' }}>Pengesahan profil selesai</h2>
        <p>Sila log masuk untuk teruskan.</p>
        <Button variant="contained" className="btn-dialog-loading" disabled={false} onClick={homePage}>
        Log Masuk
        </Button>
      </div>
    </Dialog >
  )
}

export default EKYCCheck